import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { PhoneSummary, User } from '@wml-insta/shared';
import { api } from '../api/client.js';
import { NameModal } from '../ui/NameModal.js';
import { StatusStrip } from '../ui/StatusStrip.js';
import { UpdatedNote } from '../ui/UpdatedNote.js';
import { formatNum } from '../lib/format.js';

export function PhonesPage({ me: _me }: { me: User }) {
  const [phones, setPhones] = useState<PhoneSummary[]>([]);
  const [adding, setAdding] = useState(false);

  function load() {
    api<PhoneSummary[]>('/api/phones').then(setPhones).catch(() => setPhones([]));
  }
  useEffect(load, []);

  // На карточках телефонов считаем только живые акки (архивные — в «Архиве»).
  const activeCount = (p: PhoneSummary) =>
    (p.byStatus['В работе'] ?? 0) + (p.byStatus['Прогрев'] ?? 0) + (p.byStatus['Хьюман'] ?? 0);

  return (
    <div className="page-inner">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 20, gap: 16, flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24, letterSpacing: '-0.02em' }}>Телефоны</h1>
          <div style={{ color: 'var(--text-subtle)', fontSize: 13, marginTop: 4 }}>
            {phones.length} телефонов · {formatNum(phones.reduce((s, p) => s + activeCount(p), 0))} живых акков
          </div>
        </div>
        <button className="btn-primary" style={{ width: 'auto', padding: '9px 18px' }} onClick={() => setAdding(true)}>
          + Добавить телефон
        </button>
      </div>

      {phones.length === 0 ? (
        <div className="empty-state">Телефонов пока нет — добавь первый.</div>
      ) : (
        <div className="entity-grid">
          {phones.map((p) => (
            <Link key={p.id} to={`/phone/${p.id}`} className="entity-card">
              <div className="entity-head">
                <div className="model-avatar">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <rect x="6" y="2" width="12" height="20" rx="2.5" />
                    <path d="M11 18h2" />
                  </svg>
                </div>
                <div style={{ minWidth: 0 }}>
                  <div className="entity-name">{p.name}</div>
                  <div className="entity-meta">
                    {activeCount(p)} акк. · {formatNum(p.views24h)} просм./24ч
                    {p.serial ? ` · SN ${p.serial}` : ''}
                  </div>
                  <UpdatedNote at={p.lastParsedAt} />
                </div>
              </div>
              <StatusStrip byStatus={p.byStatus} hideArchived />
            </Link>
          ))}
        </div>
      )}

      {adding && (
        <NameModal
          title="Добавить телефон"
          label="Название (например Samsung7.1)"
          submitLabel="Создать"
          onClose={() => setAdding(false)}
          onSubmit={async (name) => {
            await api('/api/phones', { method: 'POST', body: JSON.stringify({ name }) });
            load();
          }}
        />
      )}
    </div>
  );
}
